import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store/index";
import { getMicrosoftIdToken } from "@/libs/utils";
Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/login/index.vue")
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("@/views/home/index.vue"),
    children: [
      {
        path: "order",
        name: "Orders",
        component: () => import("@/views/orders/index.vue")
      },
      {
        path: "menu",
        name: "Menu",
        component: () => import("@/views/menu/index.vue")
      },
      {
        path: "message",
        name: "Messages",
        component: () => import("@/views/message/index.vue")
      },
      {
        path: "setting",
        name: "Settings",
        component: () => import("@/views/setting/index.vue")
      },
      {
        path: "history",
        name: "History",
        component: () => import("@/views/orders/history.vue")
      }
    ]
  },
  {
    path: "/conversation",
    name: "Conversation",
    component: () => import("@/views/message/conversation-details.vue")
  },
  {
    path: "/order-detail",
    name: "Order Detail",
    component: () => import("@/views/order-detail/index.vue")
  },
  {
    path: "*",
    redirect: { name: "Orders" }
  }
];

const router = new VueRouter({
  mode: "hash",
  routes
});

const LOGIN_PAGE_NAME: string = "Login";
const HomePage: string = "Home";

const clearHistoryOrdersUrl: string[] = [
  "/home/order",
  "/home/menu",
  "/home/message"
];

router.beforeEach((to, from, next) => {
  if (isUrlInIgnoreList(to.path)) {
    store.commit("handleUserCurrentHistoryDate", "");
    store.commit("handleHistoryOrder", []);
  }
  let hasToken: boolean = !!store.state.options.token;
  getMicrosoftIdToken();
  document.title = "Yamimeal";
  store.commit("handleHeaderTitle", to.name);

  if (!hasToken && to.name !== LOGIN_PAGE_NAME) {
    next({
      name: LOGIN_PAGE_NAME // 跳转到登录页
    });
  } else if (!hasToken && to.name === LOGIN_PAGE_NAME) {
    next(); // 跳转
  } else if (
    hasToken &&
    (to.name === LOGIN_PAGE_NAME || to.name === HomePage)
  ) {
    // 已登录且要跳转的页面是登录页
    next({
      name: "Orders"
    });
  } else {
    next();
  }
});

const isUrlInIgnoreList = (url: string | undefined) => {
  return url && clearHistoryOrdersUrl.some(x => url.includes(x));
};

router.afterEach(to => {
  window.scrollTo(0, 0);
});
export default router;
